import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  dialogPaper: {
    '&.MuiPaper-root': {
      borderRadius: 12,
      maxWidth: 680,
      width: '100%',
    },
  },
  dialogContent: {
    '&.MuiDialogContent-root': {
      padding: 24,
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 0,
  },
  tabWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  tabs: {
    '&.MuiTabs-root': {
      minHeight: 32,
    },
    '& .MuiTabs-indicator': {
      height: 2,
    },
  },
  tab: {
    '&.MuiTab-root': {
      minHeight: 32,
      textTransform: 'none',
      padding: '4px 12px',
      fontWeight: 600,
      color: Colors.Grey7,
      '&.Mui-selected': {
        color: Colors.Black,
      },
    },
  },
  tabIndicator: {
    backgroundColor: Colors.Black,
  },
  tabPanel: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  createShareContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  textField: {
    '&.MuiFormControl-root': {
      width: '100%',
    },
  },
  textFieldInput: {
    '&.MuiOutlinedInput-root': {
      backgroundColor: Colors.White,
      borderRadius: 2,
      border: `1px solid ${Colors.Grey3}`,
      padding: '12px 8px',
      '& fieldset': {
        border: 'none',
      },
      '&:hover fieldset': {
        border: 'none',
      },
      '&.Mui-focused fieldset': {
        border: 'none',
      },
      '& .MuiInputBase-input': {
        padding: 0,
        color: Colors.Grey7,
      },
      '& .MuiInputAdornment-root': {
        color: Colors.Grey7,
      },
    },
  },
  datePicker: {
    width: '100%',
    '& .MuiInputBase-root': {
      paddingRight: 8,
    },
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  copyButton: {
    '&.MuiButton-root': {
      textTransform: 'none',
      padding: '12px 16px',
      borderRadius: 4,
      boxShadow: 'none',
    },
  },
  searchSection: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flexWrap: 'wrap',
  },
  searchSectionContent: {
    flex: 1,
    minWidth: 0,
  },
  searchBox: {
    flex: 1,
    minWidth: 0,
    '& .MuiOutlinedInput-root': {
      border: `1px solid ${Colors.Grey11}`,
      borderRadius: 8,
      padding: '12px 8px',
      alignItems: 'center',
      gap: 6,
      '& .MuiAutocomplete-tag': {
        margin: 0,
      },
      '& .MuiAutocomplete-input': {
        padding: 0,
      },
      '& fieldset': {
        border: 'none',
      },
      '&:hover fieldset': {
        border: 'none',
      },
      '&.Mui-focused fieldset': {
        border: 'none',
      },
    },
    '& .MuiInputBase-root': {
      paddingRight: `9px !important`,
    },
  },
  selectedUserTag: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    border: '1px solid #E5E5E5',
    backgroundColor: '#F5F5F5',
    borderRadius: 4,
    height: 24,
    padding: '0 8px 0 6px',
    maxWidth: '100%',
  },
  selectedUserTagAvatar: {
    '&.MuiAvatar-root': {
      width: 16,
      height: 16,
      fontSize: 10,
    },
  },
  selectedUserTagLabel: {
    fontSize: 12,
    lineHeight: '18px',
    fontWeight: 200,
    letterSpacing: '0.48px',
    color: Colors.Grey10,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 160,
  },
  selectedUserTagRemove: {
    '&.MuiIconButton-root': {
      padding: 0,
      color: Colors.Grey10,
    },
  },
  chipsArea: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    alignItems: 'center',
    flex: 1,
  },
  chip: {
    backgroundColor: Colors.Grey2,
    borderRadius: 16,
    padding: '6px 10px 6px 6px',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    maxWidth: '100%',
  },
  chipRemove: {
    cursor: 'pointer',
    color: Colors.Grey7,
  },
  tagAvatar: {
    width: 24,
    height: 24,
    fontSize: 12,
    backgroundColor: Colors.Grey4,
  },
  input: {
    flex: 1,
    '& .MuiOutlinedInput-root': {
      padding: 0,
      '& input': {
        padding: 0,
      },
    },
  },
  inviteButton: {
    '&.MuiButton-root': {
      backgroundColor: Colors.Black,
      color: Colors.White,
      textTransform: 'capitalize',
      padding: '12px 20px',
      borderRadius: 8,
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: Colors.Grey8,
      },
    },
  },
  content: {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  accessListContainer: {
    maxHeight: 300,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
  },
  sectionTitle: {
    marginTop: 4,
  },
  personRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 0',
    borderBottom: `1px solid ${Colors.Grey11}`,
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
  personInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  avatar: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: Colors.Grey2,
  },
  personText: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  ownerBadge: {
    padding: '2px 8px',
    backgroundColor: Colors.Grey2,
    borderRadius: 12,
  },
  removeButton: {
    cursor: 'pointer',
    color: Colors.Grey7,
  },
  footer: {
    borderTop: `1px solid ${Colors.Grey11}`,
    marginTop: 4,
    paddingTop: 8,
  },
  footerItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 0',
    borderBottom: `1px solid ${Colors.Grey11}`,
    textDecoration: 'none',
    color: Colors.Grey10,
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
  footerText: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  searchDropdown: {
    position: 'absolute',
    top: 'calc(100% + 8px)',
    left: 0,
    right: 0,
    backgroundColor: Colors.White,
    border: `1px solid ${Colors.Grey11}`,
    borderRadius: 8,
    boxShadow: '0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)',
    zIndex: 2,
    overflow: 'hidden',
  },
  searchItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 12,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: Colors.Grey2,
    },
  },
  codeTag: {
    marginLeft: 4,
    color: Colors.Grey7,
  },
  iconButton: {
    color: Colors.Grey7,
  },
  searchEndAdornment: {
    display: 'flex',
    alignItems: 'center',
    pointerEvents: 'none',
    color: Colors.Grey7,
  },
  buttonSubmit: {
    '&.MuiButton-root': {
      backgroundColor: '#D32F2F',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#B71C1C',
      },
    },
  },
}));

export default useStyles;
